import request from '@/axios'


export function fetchCustomerList () {
  return request({
    url:'users/get_customer_list',
    method: 'GET'
  })
}

export function GetRoleDetail (customer_id) {
  return request({
    url:`users/get_role_details/${customer_id}`,
    method: 'GET'
  })
}
export function setTimezone (payload) {
  return request({
    url:`users/setTimeZone`,
    method: 'POST',
    data: payload
  })
}
